import i18n from '@/i18n/config';
import { bindGenogramToolName } from './utils/toolNameI18n';
import { BaseTool, IToolManifest, IToolContext, ICommand } from '../../../core/tools/interfaces/ITool';
import { useDiagramStore } from '../../../stores/diagramStore';
import { UpdatePersonCommand } from '../commands/UpdatePersonCommand';

export class ResetPersonStyleTool extends BaseTool {
  manifest: IToolManifest = {
    id: 'genogram-reset-person-style',
    name: i18n.t('genogram:tools.resetPersonStyle', { defaultValue: 'Reset Person Style' }) as string,
    icon: 'refresh',
    category: 'style',
    description: 'Reset fill and stroke to defaults for selected people',
    version: '1.0.0',
    supportedDiagramTypes: ['genogram'],
    requiresSelection: true,
    minSelection: 1,
    ui: { toolbar: false, contextMenu: false, propertyPanel: false, sidebar: false, floatingPanel: false, statusBar: false },
    capabilities: {
      modifiesShapes: true,
      createsShapes: false,
      deletesShapes: false,
      modifiesConnectors: false,
      createsConnectors: false,
      deletesConnectors: false,
      requiresUserInput: false,
      supportsMultiSelect: true,
      supportsBatchOperations: true,
    },
  };

  constructor() {
    super();
    bindGenogramToolName(this.manifest, 'tools.resetPersonStyle', 'Reset Person Style');
  }

  canExecute(context: IToolContext): boolean {
    const ids = Array.from(context.selection);
    const nodes = useDiagramStore.getState().nodes;
    return ids.some(id => nodes.some(n => n.id === id && n.type === 'person'));
  }

  execute(): ICommand[] | null {
    if (!this.context) return null;
    const ids = Array.from(this.context.selection);
    const nodes = useDiagramStore.getState().nodes;
    const personIds = ids.filter(id => nodes.some(n => n.id === id && n.type === 'person'));
    if (personIds.length === 0) return null;
    return personIds.map(id => new UpdatePersonCommand(id, { fillColor: undefined, strokeColor: undefined }));
  }
}


